// Screen `stages` — design/screens/StatusEditor.dc.html (/settings/objects/deals/fields/stage) —
// owner: S4. Status fields open the stage editor; other fields open the object builder inspector.
import { Navigate, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { StageEditorPage } from '../../../../../../features/data-model/StageEditorPage';
import { useModel } from '../../../../../../lib/queries';

const Search = z.object({ pipeline: z.string().max(63).optional().catch(undefined) });

export const Route = createFileRoute('/_settings/settings/objects/$key/fields/$fieldKey')({
  validateSearch: (s) => Search.parse(s),
  component: FieldPage,
});

function FieldPage() {
  const { key, fieldKey } = Route.useParams();
  const search = Route.useSearch();
  const model = useModel().data;
  const object = model?.objectByKey(key);
  const field = object ? model?.fieldByKey(object.id, fieldKey) : undefined;
  if (model && field && field.type !== 'status')
    return <Navigate to="/settings/objects/$key" params={{ key }} search={{ field: fieldKey }} replace />;
  return (
    <StageEditorPage
      key={`${key}.${fieldKey}`}
      objectKey={key}
      fieldKey={fieldKey}
      pipelineKey={search.pipeline}
    />
  );
}
